const parallax = {

	elem: {
		items: document.querySelectorAll('.parallax'),
	},

	init() {
		if(parallax.elem.items.length > 0) {
			window.addEventListener('scroll', parallax.reposition);
			parallax.reposition();
		}
	},

	// reposition(): set a custom property on each element indicating how far it has scrolled up the screen, and the inverse of that (which can then be used by various styles)
	reposition() {
		let screenPos = window.scrollY;
		let screenSize = window.innerHeight;
		let scrollTop = document.documentElement.scrollTop;
		parallax.elem.items.forEach(item => {
			let offset = (item.getBoundingClientRect().top + scrollTop + item.offsetHeight - screenPos) / screenSize;
			if(offset > 1) { offset = 1 };
			if(offset < 0) { offset = 0 };
			offset = Math.abs(Math.floor(offset * 100) - 100);
			let inverse = 100 - offset;
			item.style.setProperty('--offset', offset + '%');
			item.style.setProperty('--inverse-offset', inverse + '%');
		});
	}
};

export { parallax };
